import axios from 'axios';
import { authHeader, getJwt } from '../web/helpers/jwt';
import { toast } from 'react-toastify';
import { MockActions } from './MockActions';
import moment from 'moment';

export const url = () => {
  const currentDomain = window.location.origin;

  if (
    currentDomain.includes('pharma.aventis.com') ||
    currentDomain.includes('adamed.com')
  ) {
    return `${currentDomain}/api`;
  } else if (process.env.REACT_APP_ENVIRONMENT === 'senacode') {
    return 'https://lakeview-api.senacode.com';
  } else if (process.env.REACT_APP_ENVIRONMENT === 'local') {
    return 'http://localhost:8080';
  } else if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
    return 'https://api.l-v.pl';
  } else {
    return `${currentDomain}/backend`;
  }
};

const client = axios.create({
  baseURL: url(),
});

export const fetchData = async (path) => {
  try {
    const response = await client.get(path, authHeader());
    return response.data;
  } catch (error) {
    Actions.handleError(error, path);
  }
};

export const fetchBlob = async (path) => {
  try {
    const response = await client.get(path, {
      headers: {
        Accept: 'application/zip',
      },
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    Actions.handleError(error, path);
  }
};

export const Actions = {
  dataPost: (path, payload, callback) => {
    client
      .post(path, payload, authHeader())
      .then((resp) => {
        callback(resp.data);
      })
      .catch((error) => {
        Actions.handleError(error, path);
      });
  },

  post: (path, payload, callback, success, setLoader, messages, noToast) => {
    client
      .post(path, payload, authHeader())
      .then((resp) => {
        if (callback) {
          callback(resp.data);
        }
        if (!noToast) {
          toast.success(success || 'Udało się!');
        }
      })
      .catch((error) => {
        console.log("error", error.response)
        if (setLoader) {
          setLoader(false);
        }
        if (
          error.response &&
          error.response.status === 400 &&
          error.response?.data?.code === 'OPERATION_NOT_POSSIBLE'
        ) {
          toast.warn(
            messages
              ? messages['400']
              : 'Niedozwolona operacja. Zmień parametry!',
          );
          if (setLoader) {
            setLoader(false);
          }
        } else if (error.response && error.response.status === 423) {
          toast.warn(
            messages
              ? messages['423']
              : 'Nie można usunąć tego wpisu! Ten wpis już jest wykorzystywany w systemie.',
          );
          if (setLoader) {
            setLoader(false);
          }
        } else {
          // Handle other errors
          Actions.handleError(error, path);
        }
      });
  },
  put: (path, payload, callback, success, setLoader) => {
    client
      .put(path, payload, authHeader())
      .then((resp) => {
        if (callback) {
          callback(resp.data);
        }
        toast.success(success || 'Zapisano!');
      })
      .catch((error) => {
        Actions.handleError(error, path, setLoader);
      });
  },
  delete: (path, payload, callback, success, setLoader) => {
    client
      .delete(path, authHeader())
      .then((resp) => {
        if (callback) {
          callback(resp.data);
        }
        toast.success(success || 'Usunięto!');
      })
      .catch((error) => {
        if (error.response && error.response.status === 423) {
          toast.warn(
            'Nie można usunąć tego wpisu! Ten wpis już jest wykorzystywany w systemie.',
          );
          if (setLoader) {
            setLoader(false);
          }
        } else {
          // Handle other errors
          Actions.handleError(error, path);
        }
      });
  },

  get: (path, callback, errorCallback) => {
    let action = MockActions.get(path, callback);
    if (action) {
      return;
    }

    client
      .get(path, authHeader())
      .then((resp) => {
        callback(resp.data);
      })
      .catch((error) => {
        if (errorCallback) {
          errorCallback();
        } else {
          Actions.handleError(error, path);
        }
      });
  },

  getBlob: (path, callback, errorCallback) => {
    client
      .get(path, {
        ...authHeader(),
        responseType: 'blob',
      })
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => {
        if (errorCallback) {
          errorCallback(err);
        } else {
          console.error('getBlob error:', err);
        }
      });
  },



  download: (path, fileName, format = 'pdf') => {
    client
      .get(path, {
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${getJwt()}`,
        },
      })
      .then(function (response) {
        const blob = new Blob([response.data], {
          type: `application/${format}`,
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${fileName.toLowerCase()}-${moment(new Date()).format('YYYY-MM-DD-HH-mm-ss')}.${format}`,
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch(function (error) {
        Actions.handleError(error, path);
      });
  },

  isTokenInvalid: (r) => {
    console.log(r);
    if (r.response && r.response.status === 401) {
      if(getJwt()){
        localStorage.removeItem('user_jwt');
        window.location.reload();
      }


      return true;
    } else if (r.response && r.response.status === 403) {
      toast.error('Dostęp zabroniony!');
      return true;
    }
  },

  handleError: (error, path, setLoader) => {
    console.log(error);
    if (setLoader) {
      setLoader(false);
    }
    const tokenInvalid = Actions.isTokenInvalid(error);
    if (!tokenInvalid) {
      toast.error(
        `Wystąpił nieoczekiwany błąd! Przekaż te informację do administratora: [${path}];[${error}]`,
        {
          autoClose: false,
        },
      );
    }
  },
};
